var _rect, _rect2, _rect3, _rect4, _circle, _circle2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpreaderTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25.47 12.19",
    style: {
      enableBackground: "new 0 0 25.47 12.19"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.83,
    y: 1.71,
    width: 2.48,
    height: 0.83,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 3.36,
    width: 3.31,
    height: 0.83,
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.65,
    y: 5.01,
    width: 1.65,
    height: 0.83,
    fill: "currentColor"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11.99,
    y: 8.32,
    width: 3.31,
    height: 2.48,
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.3,
    cy: 10.18,
    r: 1.86,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.99,
    cy: 10.18,
    r: 1.86,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.54,7.49V2.12c0-0.25-0.17-0.41-0.41-0.41h-1.65l-2.73-1.36c-0.91-0.45-1.94-0.45-2.85,0L7.11,1.25L8.6,1.58 c0.12,0.04,0.12,0.12,0.08,0.17H6.2H4.55c-0.25,0-0.41,0.17-0.41,0.41v5.38h1.24v2.48H4.14v1.65h1.65c0.45,0,0.83-0.37,0.83-0.83 V7.54h9.92V7.49z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.94,8.2c0.04-0.74,0.45-1.16,0.83-1.36c0.17-0.12,0.12-0.37-0.08-0.37c-0.69-0.07-1.41,0.16-1.94,0.7V5.68 c0-0.45-0.08-0.87-0.21-1.28l-0.79-2.61c-0.17-0.54-0.62-0.87-1.2-0.87h-3.18v6.62h0.62c1.49,0,2.69,1.2,2.69,2.69 c0,0.08,0,0.12,0,0.21h1.81c0.18,0.25,0.39,0.47,0.63,0.66l2.36-0.83C25.47,10.27,23.86,9.56,23.94,8.2z M19.02,5.01V2.12h1.57 l0.79,2.61c0.04,0.08,0.04,0.17,0.04,0.29H19.02z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpreaderTruck);
export default __webpack_public_path__ + "static/media/spreader-truck.73c564cbd12bb34386870fb23db3979f.svg";
export { ForwardRef as ReactComponent };